/*
 * @Author: your name
 * @Date: 2022-04-26 14:44:41
 * @LastEditTime: 2024-10-16 10:40:54
 * @LastEditors: 王峥 wangzheng_jzb@tal.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /yach_31_record/packages/auxiliary_ability/src/errorHandler.ts
 */
import { get } from 'lodash-es';
import { Toast } from 'antd-mobile';
import eventBus from '@utils/events';

const NETWORK_ERRORS_PREFIX = ['network error', 'connect etimedout', 'getaddrinfo enotfound'];
const REQUEST_TIMEOUT_PREFIX = ['timeout of '];

/**
 * check if is specific error
 *
 * @param {string} msg
 * @param {('network' | 'timeout')} type
 * @returns
 */
function checkErrorType(msg: string, type: 'network' | 'timeout') {
    msg = msg.toLowerCase();
    const prefixs = type === 'network' ? NETWORK_ERRORS_PREFIX : REQUEST_TIMEOUT_PREFIX;
    for (const p of prefixs) {
        if (msg.startsWith(p)) {
            return true;
        }
    }
    return false;
}

/**
 * define error msg
 *
 * @export
 * @enum {number}
 */
export enum ERROR_TYPE {
    COMMON_NETWORK_ERROR = 'network error',
    NETWORK_OFFLINE = 'you are offline',
    REQUEST_TIMEOUT = 'request timeout',
}

function toastError(e: any) {
    const errMsg: string = get(e, 'reason.response.data.message') || get(e, 'reason.message') ;
    return;
    if (errMsg && typeof errMsg === 'string') {
        if (checkErrorType(errMsg, 'network')) {
            return Toast.show({
                content: ERROR_TYPE.COMMON_NETWORK_ERROR,
                duration: 2000,
            });
            // return message.error(ERROR_TYPE.COMMON_NETWORK_ERROR);
        }
        if (checkErrorType(errMsg, 'timeout')) {
            return Toast.show({
                content: ERROR_TYPE.REQUEST_TIMEOUT,
                duration: 2000,
            });
            // return message.error(ERROR_TYPE.REQUEST_TIMEOUT);
        }
        // message.error(errMsg);
        Toast.show({
            content: errMsg,
            duration: 2000,
        });
    }
}

function handleError(e: any) {
    eventBus.emit('unhandledrejection', e);
    console.error(e);
    toastError(e);
}

/**
 * catch unhandledrejection and toast
 *
 * @export
 */
export default function catchUnhandledRejection() {
    window.addEventListener('unhandledrejection', handleError);
}
